import htmlToNode from "@util/htmlToNode";

export const refreshPanierBadge = () => {
  const btnPanierBadge = document.querySelector(".Header-panierWrapBadge");

  if (!btnPanierBadge || !btnPanierBadge.dataset.view) return;

  fetch(btnPanierBadge.dataset.view, {
    credentials: "include",
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      btnPanierBadge.innerHTML = "";

      if (html){
        const Component = htmlToNode(html);
        btnPanierBadge.appendChild(Component);
      }
    });
};

export default () => {
  const togglers = [...document.querySelectorAll("[data-toggle-header]")];
  const headerWrapper = document.querySelector(".Header-wrapper");

  if (!headerWrapper || !togglers) return;

  togglers.forEach(el => {
    el.addEventListener("click", function() {
      headerWrapper.classList.toggle("is-active");

      togglers.forEach(elem => {
        elem.classList.toggle("is-active");
      });
    });
  });

  refreshPanierBadge();
};



// WEBPACK FOOTER //
// ./components/Header/Header.js